import { EmbeddableLocation } from './EmbeddableLocation';

export class Lane {
  origin?: EmbeddableLocation;
  destination?: EmbeddableLocation;

  constructor(opts?: Partial<Lane>) {
    if (opts?.origin != null) {
      this.origin = new EmbeddableLocation(opts.origin);
    }
    if (opts?.destination != null) {
      this.destination = new EmbeddableLocation(opts.destination);
    }
  }
}
